<template lang="pug">
.cms-item(:class="{minimize}")
  .right
    pre {{nestedBlock}}
    .block-headline(v-if="nestedBlock && nestedBlock.blockModel") {{nestedBlock.name}}
    component(v-if="nestedBlock && nestedBlock.component" :is="nestedBlock.component" @updateValue="(val) => $emit('updateValue', val)" :value="value")
    slot
    .dots
      .dot.close(@click="$emit('delete')")
</template>

<script>
import Text_v1 from '@/components/cms/Text_v1.vue';
import RichText_v1 from '@/components/cms/RichText_v1.vue';
import RentObject_v1 from '@/components/cms/RentObject_v1.vue';
import Image_v1 from '@/components/cms/Image_v1.vue';
import Pdf_v1 from '@/components/cms/Pdf_v1.vue';
import Cta_v1 from '@/components/cms/Cta_v1.vue';

export default {
  name: "CMSBlock",
  components: {
    Text_v1,
    RichText_v1,
    RentObject_v1,
    Image_v1,
    Pdf_v1,
    Cta_v1,
  },
  props: {
    value: {
      type: Object
    },
    nestedBlock: {
      type: Object
    }
  },
  data() {
    return {
      minimize: false
    };
  },
  methods: {
  }
}
</script>

<style lang="scss">
.block-headline {
  text-transform: uppercase;
  font-weight: 500;
  font-size: 14px;
  color: $darkgray;
  margin-top: $lg-space;
  margin-bottom: $md-space;
}
</style>

<style lang="scss" scoped>
.cms-item {
  position: relative;
  display: inline-flex;
  margin: $sm-space 0;
  padding: $sm-space;
  // border-radius: 6px;
  display: flex;
  justify-content: flex-start;
  // overflow: hidden;
  border: solid 1px rgb(236, 236, 236);
  border-left: solid 1px $gray;
  // box-shadow: $shadow-sm;
  background-color: rgba(white, 1);
  &:hover {
    .dots {
      opacity: 1;
    }
  }
  &.minimize {
    height: 100px;
    overflow: hidden;
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: calc(100% - 20px);
      z-index: 10;
      background: linear-gradient(to top, white, transparent);
    }
  }
  .dots {
    transition: opacity 200ms ease;
    opacity: 0;
    position: absolute;
    top: 8px;
    right: 8px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .dot {
      height: 12px;
      width: 12px;
      margin-left: 8px;
      border-radius: 100%;
      &.close {
        background: linear-gradient(to top, #ff5952, rgba(#ff5952, 0.6));
        border: solid 2px transparent;
        &:hover {
          border: solid 2px darken(#ff5952, 8%);
          cursor: pointer;
        }
      }
      &.minimize {
        background: linear-gradient(to top, #ffbd35, rgba(#ffbd35, 0.6));
        border: solid 2px transparent;
        &:hover {
          border: solid 2px darken(#ffbd35, 8%);
          cursor: pointer;
        }
      }
      &.expand {
        background: linear-gradient(to top, #2ec93d, rgba(#2ec93d, 0.6));
        border: solid 2px transparent;
        &:hover {
          border: solid 2px darken(#2ec93d, 8%);
          cursor: pointer;
        }
      }
    }
  }

  .right {
    // padding: 0 1px;
    margin: 16px;
    width: 100%;
    height: auto;
    box-sizing: border-box;
  }
}
</style>